import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../lib/api-client";
import { Retailer } from "../types/CompanyDetails";

export const useGetRetailers = () => {

	const { data, isLoading } = useQuery({
		queryKey: ['retailers'],
		queryFn: async () => await apiClient.get('company/retailers') as Retailer[]
	});

	return {
		data: data || [],
		isLoading
	};
};